import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";
import { ImageSourceKinds, IDocumentImageSource } from "../../../../documaker/domain/document";

export class EditableFormatTemporaryImageSource extends AbstractSource implements IDocumentImageSource {
  constructor(
    getToken: () => string,
    private _imageSourceKind: ImageSourceKinds,
    public imageGuid: string,
    public quotedFormatId?: number
  ) {
    super(getToken);
  }

  public get imageSourceKind(): ImageSourceKinds {
    return this._imageSourceKind;
  }

  public set imageSourceKind(kind: ImageSourceKinds) {
    this._imageSourceKind = kind;
  }

  protected getSource(): string {
    const guid = this.imageGuid
      ? this.imageGuid
      : "dummyImageKey"; // 下地が無いフォーマットへの暫定対応。空にするとimg要素で画像が無いことを表すマークを表示してしまうため。
    const url = "/api/format-editor/temporary/image/" + guid + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatTemporaryImageSource(
      this._getToken,
      this.imageSourceKind,
      this.imageGuid,
      this.quotedFormatId
    );
  }
}
